// @ts-nocheck
import {useTranslation} from "react-i18next";
import {toast} from "@/components";

const useAddTicket = () => {
  const {t} = useTranslation();

  const addTicket = elements => {
    const {selectedSorteo, animalsSelected, betAmount, tickets, data, game} = elements;
    let updatedTickets = [];

    if (!selectedSorteo || animalsSelected.length === 0 || betAmount === null || betAmount < 1) {
      toast.error({title: t("lotteryErrorSelectDrawAnimal")});
      return;
    }

    if (betAmount > 45 || betAmount < 15) {
      toast.warning({title: t("lotteryErrorBetAmount")});
      return;
    }

    const existingSorteoIndex = tickets.findIndex(ticket => ticket.id === selectedSorteo);

    if (existingSorteoIndex !== -1) {
      // Add selected animals to the existing sorteo ticket
      updatedTickets = [...tickets];
      animalsSelected.forEach(animal => {
        const existingJugadaIndex = updatedTickets[existingSorteoIndex].jugadas.findIndex(
          jugada => jugada.jugadas[0].id === animal.id
        );
        if (existingJugadaIndex !== -1) {
          updatedTickets[existingSorteoIndex].totalAmountTicket += betAmount;
          updatedTickets[existingSorteoIndex].jugadas[existingJugadaIndex].monto += betAmount;
        } else {
          updatedTickets[existingSorteoIndex].totalAmountTicket += betAmount;
          updatedTickets[existingSorteoIndex].jugadas.push({
            monto: betAmount,
            jugadas: [{id: animal.id}],
          });
        }
      });

      return updatedTickets;
    } else {
      // Create a new ticket for the selected sorteo
      let totalAmountBet = 0;

      animalsSelected.forEach(() => {
        totalAmountBet += betAmount;
      });

      const newTicket = {
        id: selectedSorteo,
        hora: data.sorteos.find(s => s.id === selectedSorteo).hora,
        loteria_id: game.id,
        jugadas: animalsSelected.map(animal => ({
          monto: betAmount,
          jugadas: [{id: animal.id}],
        })),
        totalAmountTicket: totalAmountBet,
      };

      return [...tickets, newTicket];
    }
  };

  return {
    addTicket,
  };
};

export default useAddTicket;
